/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconHeart16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHeart16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.403 2.987C3.1 2.29 4.035 2 5 2c1.402 0 2.388.748 3 1.778C8.607 2.75 9.587 2 11 2c.964 0 1.9.291 2.596.987.698.698 1.07 1.72 1.07 3.013 0 1.85-1.119 3.57-2.393 4.909C10.98 12.265 9.42 13.422 8.307 14h-.614c-1.114-.578-2.675-1.735-3.966-3.091C2.452 9.569 1.333 7.849 1.333 6c0-1.294.372-2.315 1.07-3.013Zm.943.943c-.385.385-.68 1.03-.68 2.07 0 1.33.828 2.73 2.027 3.99C5.758 11.108 7.032 12.119 8 12.667c.968-.548 2.242-1.559 3.307-2.677 1.198-1.26 2.026-2.66 2.026-3.99 0-1.04-.294-1.685-.68-2.07-.387-.388-.951-.597-1.653-.597-1.216 0-2 1-2.334 2.334l-1.308-.003C7 4.334 6.204 3.334 5 3.334c-.703 0-1.266.208-1.654.596Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHeart24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHeart24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.605 4.48C4.65 3.437 6.053 3 7.5 3c2.103 0 3.583 1.123 4.5 2.667C12.912 4.125 14.38 3 16.5 3c1.447 0 2.851.437 3.895 1.48C21.442 5.527 22 7.06 22 9c0 2.774-1.678 5.354-3.59 7.363-1.938 2.035-4.279 3.77-5.95 4.637h-.92c-1.671-.867-4.012-2.602-5.95-4.637C3.679 14.354 2 11.774 2 9c0-1.94.558-3.473 1.605-4.52ZM5.02 5.895C4.442 6.473 4 7.44 4 9c0 1.996 1.242 4.096 3.04 5.984C8.636 16.663 10.547 18.178 12 19c1.452-.822 3.363-2.337 4.96-4.016C18.759 13.096 20 10.996 20 9c0-1.56-.442-2.527-1.02-3.105C18.4 5.313 17.553 5 16.5 5c-1.823 0-3 1.5-3.5 3.5l-1.962-.004C10.5 6.5 9.308 5 7.5 5c-1.053 0-1.899.313-2.48.895Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconHeart = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHeart(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconHeart16 {...iconProps} />;
        case '24':
            return <IconHeart24 {...iconProps} />;
        default:
            return <IconHeart24 {...iconProps} />;
    }
});
